import names from "./src/names.js";
import phases from "./src/phases.js";
import { init as initializeSettings } from "./src/settings.js";
import settings from "./src/settings.js";
import generateQrCode from "./src/generateQrCode.js";
import setDeep from "./src/setDeep.js";
import log, { ALL_NAMESPACES } from "./src/debug.js";
import * as generateString from "./src/generateString.js";
import assignPositions from "./src/results/assignPositions.js";
import pointAllocation from "./src/results/pointAllocation.js";
import Results from "./src/results/index.js";

const generatePartyID = generateString.partyID;
const generatePlayerID = generateString.playerID;
const generateRandomString = generateString.randomString;
const generateRoundID = generateString.roundID;

export { PLAYER_COLORS, PLAYER_COLOR_HEX, hexToPhaser } from "./src/playerColors.js";
export type { PlayerColor } from "./src/playerColors.js";

export {
	names,
	phases,
	generateRandomString,
	generatePartyID,
	generatePlayerID,
	generateRoundID,
	initializeSettings,
	settings,
	generateQrCode,
	setDeep,
	log,
	ALL_NAMESPACES,
	assignPositions,
	pointAllocation,
	Results,
};

export default {
	names,
	phases,
	generateString,
	generatePartyID,
	generatePlayerID,
	initializeSettings,
	settings,
	generateQrCode,
	setDeep,
	log,
	assignPositions,
	pointAllocation,
	Results,
};
